import { ICategoryNameLocale, IEditCategoryDTO } from '@/models/categories.model';
import { EditCategoryFieldNames, TEditCategoryFormValues } from '../helpers/types';

class EditCategoryDTO implements IEditCategoryDTO {
  locale?: ICategoryNameLocale[];
  parent_id?: string;
  slug?: string;
  google_feed_id?: number;
  is_restoration?: boolean;
  is_heavy?: boolean | null;
  photo?: File;

  constructor(values: TEditCategoryFormValues) {
    this.locale = values[EditCategoryFieldNames.LOCALE];
    this.slug = values[EditCategoryFieldNames.SLUG];
    this.google_feed_id = values[EditCategoryFieldNames.GOOGLE_FEED_ID];
    this.is_restoration = values[EditCategoryFieldNames.IS_RESTORATION] ?? false;
    this.is_heavy = values[EditCategoryFieldNames.IS_HEAVY] ? true : null;

    if (values[EditCategoryFieldNames.PARENT_ID]) {
      this.parent_id = values[EditCategoryFieldNames.PARENT_ID];
    }

    if (values[EditCategoryFieldNames.PHOTO]?.file?.originFileObj) {
      this.photo = values[EditCategoryFieldNames.PHOTO].file.originFileObj;
    }
  }
}

export default EditCategoryDTO;
